import { render, staticRenderFns } from "./InputBox.vue?vue&type=template&id=904e360e"
import script from "./InputBox.vue?vue&type=script&setup=true&lang=js"
export * from "./InputBox.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports